import { useAppSelector } from '@hooks/app/redux';
import { getPendingActionsBase } from '@services/external/pendingActions.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ACTION_NAMES } from './pendingActions.utils';

async function handler(providerId: string) {
  const { data } = await getPendingActionsBase(providerId);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function usePendingActionsBase(
  options?: UseQueryOptions<TQueryData | null, unknown, TQueryData, any>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery([ACTION_NAMES.base, providerId], () => handler(providerId), {
    ...options,
    enabled: options?.enabled ?? !!providerId,
  });
}

export default usePendingActionsBase;
